import { h } from '@stencil/core';

const Pragotron = () => {
  return (
    <svg width="158" height="86" viewBox="0 0 158 86" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dddii_823_8925)">
        <rect x="4" y="6" width="150" height="75" rx="10" fill="#040205" />
      </g>
      <rect x="7" y="9" width="144" height="69" rx="7" fill="#39363A" />
      <rect x="7" y="9" width="144" height="69" rx="7" fill="url(#paint0_linear_823_8925)" />
      <rect x="5" y="33" width="4" height="22" rx="2" fill="url(#paint1_linear_823_8925)" stroke="black" stroke-width="2" />
      <rect x="1" y="-1" width="4" height="22" rx="2" transform="matrix(-1 0 0 1 154 34)" fill="url(#paint2_linear_823_8925)" stroke="black" stroke-width="2" />
      <g opacity="0.3" filter="url(#filter1_d_823_8925)">
        <path d="M10 44C10 44 103 44.1667 148 44" stroke="black" stroke-width="2" />
      </g>
      <defs>
        <filter id="filter0_dddii_823_8925" x="0" y="0" width="158" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_823_8925" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_823_8925" result="effect2_dropShadow_823_8925" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_823_8925" result="effect3_dropShadow_823_8925" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_823_8925" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect4_innerShadow_823_8925" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect4_innerShadow_823_8925" result="effect5_innerShadow_823_8925" />
        </filter>
        <filter id="filter1_d_823_8925" x="5.99869" y="41" width="146.005" height="10.0741" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_823_8925" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_823_8925" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_823_8925" x1="79" y1="9" x2="79" y2="19.7715" gradientUnits="userSpaceOnUse">
          <stop stop-color="#040205" />
          <stop offset="1" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="paint1_linear_823_8925" x1="7" y1="34" x2="7" y2="54" gradientUnits="userSpaceOnUse">
          <stop stop-color="#383539" />
          <stop offset="0.166667" stop-color="#686669" />
          <stop offset="0.41875" stop-color="#130F14" />
          <stop offset="0.71875" stop-color="#3C393D" />
          <stop offset="1" stop-color="#020002" />
        </linearGradient>
        <linearGradient id="paint2_linear_823_8925" x1="1" y1="0" x2="1" y2="20" gradientUnits="userSpaceOnUse">
          <stop stop-color="#383539" />
          <stop offset="0.166667" stop-color="#686669" />
          <stop offset="0.41875" stop-color="#130F14" />
          <stop offset="0.71875" stop-color="#3C393D" />
          <stop offset="1" stop-color="#020002" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Pragotron;
